import dmi from './utils/deep-merge-inmutable';
import base from './base';
export default dmi(base, {
    message: {
        publishedEforms: {
            paginator: {
                rowsByPage: "Resultados por página",
            }
        },
        userActive: {
            dni: "Cédula de identidad",
            cuil: "Cédula de identidad",
            cuils: "Cédulas de identidad",
        },
        label: {
            dni: "CEDULA",
        },
        publishDocuments: {
            configIndivualPublish: {
                inputCuil: {
                    label: "CI",
                    question: "¿Cuál es el CI del colaborador?",
                    description: "Ingresa el CI del colaborador al que quieres enviarle un documento"
                },
            }
        },
        certificates: {
            newCertificate: {
                personalInfo: {
                    dni: "Cédula",
                },
                dni: "CI"
            }
        },
        documentDetail: {
            commons: {
                cuil: "Cédula de identidad",
            }
        }
    }
})